import { defineStore } from 'pinia';
import { downloadBlobAs, getExportFilename } from '@/helpers/downloadHelpers';
import { activeFabricCanvas } from '@/fabric/canvas';
import { useBackgroundStore } from '@/stores/useBackgroundStore';

type ExportResult =
  | {
    ok: true;
    blob: Blob;
    filename: string;
  }
  | {
    ok: false;
    message: string;
  };

export const useSystemStore = defineStore('system', () => {
  async function generatePngExport (): Promise<ExportResult> {
    const backgroundStore = useBackgroundStore();

    if (!backgroundStore.hasBackgroundImage) {
      return {
        ok: false,
        message: 'Voeg eerst een afbeelding toe voordat je exporteert.',
      };
    }

    if (!activeFabricCanvas) {
      return {
        ok: false,
        message: 'Het canvas is nog niet klaar om te exporteren.',
      };
    }

    activeFabricCanvas.discardActiveObject();
    activeFabricCanvas.renderAll();

    const blob = await new Promise<Blob>((resolve, reject) => {
      activeFabricCanvas.lowerCanvasEl.toBlob((createdBlob) => {
        if (!(createdBlob instanceof Blob)) {
          reject(new Error('Kon geen PNG genereren.'));
          return;
        }

        resolve(createdBlob);
      }, 'image/png', 1);
    });

    return {
      ok: true,
      blob,
      filename: getExportFilename({
        extension: 'png',
      }),
    };
  }

  function downloadPng (blob: Blob, filename: string) {
    return downloadBlobAs(blob, filename);
  }

  return {
    generatePngExport,
    downloadPng,
  };
});
